import { StyledButton } from './Button.styles';

export type ButtonVariant = 'text' | 'contained' | 'outlined';

export type ButtonIntent = 'primary' | 'warning';

export const Button = StyledButton;
